<script>
  import LinkMolecule from '~/Components/Molecules/Link'
  import {Link} from 'svelte-routing'
  export let card = {}
</script>

<div class="card">

  <Link to={card.link}>

    <div class="card__large">

      <img src={card.icon_url} alt="" class="card__icon">
      
      <h3 class="card__headline">{card.title}</h3>

      <p class="card__content">{card.content}</p>

      <LinkMolecule to={card.link} className="card__large" cta="Learn more" />

    </div>

  </Link>

</div>

<style lang="scss">
  .card {

    $this: &;

    max-width: 33%;

    @media only screen and (max-width: 576px) {
      max-width: unset;
    }
    
    &__large {
      background: white;
      z-index: 10;
      box-shadow: 0px 30px 50px rgba(95, 105, 131, 0.08);
      border-radius: 1rem;
      padding: 2.5rem;
      margin-right: 1rem;
      margin-bottom: 1rem;
      #{$this}__headline {
        font-weight: bold;
        margin-bottom: 1.25rem;
      }
      #{$this}__icon {
        margin-bottom: 3.125rem;
      }
      #{$this}__content {
        margin-bottom: 2.5rem;
        max-height: 10rem;
      }
    }
  }
</style>